/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm , theme, themeV2, coloredScrollBar} from '@insticator/insticator-ui';



/* ++++++++++ --------------- NAV : STYLES --------------- ++++++++++ */
export default {
	migrationstatuswidget: {
    position: 'absolute',
    right: '-125px',
    zIndex: 999,
    bottom: pxToEm(10),
    '& .arrow': {
      background: '#FFF',
      border: 'solid #FFF',
      borderWidth: `0 8px 8px 0`,
      padding: pxToEm(3),
      display: 'inline-block',
      position: 'absolute',
      right: pxToEm(30),
      bottom: pxToEm(-8),
      transform: `rotate(45deg)`,
      '-webkit-transform': `rotate(45deg)`,
    },
    '& .toggle': {
      background: theme.color.primary.medium.swatch,
      border: `1px solid ${theme.color.primary.medium.swatch}`,
      borderRadius: pxToEm(100),
      padding: pxToEm(8),
      width: pxToEm(54),
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '&.status-progress': {
        background: '#FDE6D2',
        '& path': {
          fill: '#F88923'
        },
        border: '1px solid #F88923'
      },
      '&.status-error': {
        background: '#FCD6D8',
        '& path': {
          fill: '#F03840'
        },
        border: '1px solid #F03840'
      },
      '&.status-data_migration_ready': {
        '&.canstartmigration-false': {
          background: '#FDE6D2',
          '& path': {
            fill: '#F88923'
          },
          border: '1px solid #F88923'
          }
      }
    },
    '& .popover': {
      opacity: 0,
      visibility: 'hidden',
      background: '#FFF',
      borderRadius: pxToEm(16),
      width: '200px',
      transition: 'all 150ms linear',
      left: pxToEm(-160),
      top: pxToEm(-16),
      position: 'relative',
      padding: `${pxToEm(16)} ${pxToEm(12)}`,
      boxShadow: '0px 10px 35px 0px rgba(0, 0, 0, 0.1)',
      fontSize: pxToEm(14),
      '&.isopen-true': {
        opacity: 1,
        visibility: 'visible'
      },
      '& .info': {
        display: 'flex',
        gap: pxToEm(8),
        alignItems: 'center'
      },
      '& .button': {
        width: '100%',
        borderRadius: pxToEm(66),
        color: '#FFFFFF',
        '& span': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: pxToEm(8)
        }
      },
      '& .name-times-circle': {
        position: 'absolute',
        top: pxToEm(8),
        right: pxToEm(8),
        cursor: 'pointer',
        '& i': {
          fontSize: pxToEm(18)
        }
      }
    }
  }
}; 